import { merge } from 'lodash';
import { defaultTheme } from 'tuui';

export const chatAgentTheme = (() => {
    //Add theme here when needed
    const difference = {};
    const tempTheme = merge({}, defaultTheme, difference);

    return tempTheme;
})();
